<template>
  <EvaluationActionIndicator icon="sr-2 sr-v2-heart-filled" bg-color="bg-pink-300" />
</template>

<script>
import EvaluationActionIndicator from "./EvaluationActionIndicator";

export default {
  components: { EvaluationActionIndicator }
};
</script>